import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Info as InfoIcon, Email as EmailIcon, Phone as PhoneIcon, Payment as PaymentIcon } from '@mui/icons-material';

interface RechargeDialogProps {
  open: boolean;
  onClose: () => void;
  userEmail: string;
}

const RechargeDialog: React.FC<RechargeDialogProps> = ({ open, onClose, userEmail }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Nạp coins
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
          <Paper 
            elevation={3} 
            sx={{ 
              p: 2, 
              bgcolor: 'background.paper',
              borderRadius: 2,
              width: '100%',
              maxWidth: 400
            }}
          >
            <Typography variant="h6" gutterBottom align="center" color="primary">
              Thông tin thanh toán
            </Typography>
            <Typography variant="body1" gutterBottom align="center" color="error.main" sx={{ fontWeight: 'bold' }}>
              Chi phí: 100đ / 1 coin
            </Typography>
            
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
              <img 
                src="/qr_tpbank.jpg" 
                alt="QR Code thanh toán" 
                style={{ 
                  maxWidth: '100%', 
                  height: 'auto',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0'
                }} 
              />
            </Box>

            <List>
              <ListItem>
                <ListItemIcon>
                  <InfoIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Lưu ý quan trọng" 
                  secondary="Khi chuyển khoản, vui lòng ghi chú email của bạn để chúng tôi có thể cập nhật coins cho tài khoản của bạn."
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <EmailIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Đây là email của bạn" 
                  secondary={userEmail}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <PaymentIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Sau khi chuyển khoản" 
                  secondary="Vui lòng chụp ảnh biên lai và gửi cho chúng tôi qua một trong các kênh sau:"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <PhoneIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Zalo" 
                  secondary="0348542412"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <EmailIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Email" 
                  secondary="linhnn.developer@gmail.com"
                />
              </ListItem>
            </List>
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RechargeDialog; 